import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      nav: { home: "Accueil", tv: "TV", radio: "Radio", provinces: "Provinces", rankings: "Classement", favorites: "Favoris", profile: "Profil" },
      common: {
        search_placeholder: "Rechercher une télévision ou une radio…",
        login: "Connexion", login_register: "Connexion / Inscription", logout: "Déconnexion",
        register_media: "Inscrire mon média", admin: "Super Admin", media_space: "Espace Média",
        see: "Voir", cancel: "Annuler", search: "Rechercher…", login_required: "Connectez-vous pour cette action.",
      },
      footer: { register: "Inscrire mon média", manager: "Espace Gestionnaire", admin: "Administration" },
      home: {
        live_now: "En direct maintenant", my_province: "Médias de {{name}}",
        popular_tv: "Télévisions populaires", popular_radio: "Radios populaires",
        most_viewed: "Les plus regardées / écoutées", new_media: "Nouveaux médias",
        certified: "Chaînes certifiées", certified_see_all: "Voir tout",
        cta_title: "Vous gérez une chaîne TV ou une radio ?",
        cta_sub: "Rejoignez le portail national et diffusez auprès de tout le pays.",
        cta_btn: "Inscrire mon média",
      },
      provinces: { title: "Les 26 provinces", subtitle: "Explorez les médias de chaque province de la République Démocratique du Congo." },
      livemap: {
        title: "Audience en direct", viewers: "spectateurs", top_provinces: "Top provinces en direct",
        top_countries: "Top pays en direct", world: "Monde", rdc: "RDC",
        no_viewers: "Aucun spectateur actif en ce moment.", legend: "Affluence",
        click_hint: "Cliquez sur un pays pour voir les chaînes qui y sont regardées.",
        channels_watched: "Chaînes regardées depuis ce pays (7 derniers jours)",
        no_channels: "Aucune chaîne regardée depuis ce pays récemment.",
        realtime_note: "Mise à jour automatique toutes les 25 s · spectateurs actifs des 2 dernières minutes.",
      },
      browse: {
        tv: "Télévisions", radio: "Radios", all_media: "Tous les médias", count: "{{n}} média(s) disponible(s)",
        all: "Tout", province: "Province", all_provinces: "Toutes provinces", language: "Langue", all_languages: "Toutes langues",
        category: "Catégorie", all_categories: "Toutes catégories",
        sort_popular: "Populaire", sort_live: "En direct", sort_recent: "Récent", sort_name: "Nom (A-Z)",
        certified_only: "Certifiées", certified_hint: "Chaînes officiellement certifiées (soutien possible)",
        empty: "Aucun média ne correspond à ces filtres.",
      },
      detail: {
        listen_live: "Écouter le direct", listening: "En écoute", support: "Soutenir", favorites: "Favoris", saved: "Enregistré",
        copy_link: "Copier le lien", on_air: "À l'antenne", view_grid: "Voir la grille", hide_grid: "Masquer la grille",
        today: "Aujourd'hui", no_program: "Pas de programme prévu aujourd'hui.", ongoing: "en cours", remind: "Me rappeler",
        discover_also: "À découvrir aussi", comments: "Commentaires", reply_to: "Réponse à", your_reply: "Votre réponse…",
        add_comment: "Ajouter un commentaire…", login_to_comment: "Connectez-vous pour commenter", be_first: "Soyez le premier à commenter !",
        reply: "Répondre", report_success: "Commentaire signalé à la modération.", favorite_added: "Ajouté aux favoris",
        favorite_removed: "Retiré des favoris", following: "Vous suivez ce média", unfollowed: "Suivi annulé",
        reminder_on: "Rappel activé — vous serez notifié avant le début", reminder_off: "Rappel désactivé",
        link_copied: "Lien copié !", edited: "modifié", certified: "Certifiée",
        pinned: "Épinglé", official_reply: "Réponse officielle",
      },
      auth: {
        login_title: "Bon retour", login_sub: "Connectez-vous pour retrouver vos médias favoris",
        register_title: "Créer un compte", register_sub: "Rejoignez la communauté des Chaînes Numériques de la RDC",
        email: "Email", password: "Mot de passe", first_name: "Prénom", last_name: "Nom",
        login_btn: "Se connecter", register_btn: "Créer mon compte", or: "ou", google: "Continuer avec Google",
        no_account: "Pas encore de compte ?", have_account: "Déjà un compte ?", signup_link: "Inscrivez-vous",
        login_link: "Connectez-vous", forgot: "Mot de passe oublié ?", loading: "Veuillez patienter…",
      },
    },
  },
  en: {
    translation: {
      nav: { home: "Home", tv: "TV", radio: "Radio", provinces: "Provinces", rankings: "Rankings", favorites: "Favorites", profile: "Profile" },
      common: {
        search_placeholder: "Search for a TV or radio station…",
        login: "Sign in", login_register: "Sign in / Sign up", logout: "Sign out",
        register_media: "Register my channel", admin: "Super Admin", media_space: "Media Space",
        see: "View", cancel: "Cancel", search: "Search…", login_required: "Please sign in for this action.",
      },
      footer: { register: "Register my channel", manager: "Manager Space", admin: "Administration" },
      home: {
        live_now: "Live now", my_province: "Channels from {{name}}",
        popular_tv: "Popular televisions", popular_radio: "Popular radios",
        most_viewed: "Most watched / listened", new_media: "New channels",
        certified: "Certified channels", certified_see_all: "See all",
        cta_title: "Do you run a TV or radio station?",
        cta_sub: "Join the national portal and broadcast to the whole country.",
        cta_btn: "Register my channel",
      },
      provinces: { title: "The 26 provinces", subtitle: "Explore the channels of every province of the Democratic Republic of Congo." },
      livemap: {
        title: "Live audience", viewers: "viewers", top_provinces: "Top live provinces",
        top_countries: "Top live countries", world: "World", rdc: "DRC",
        no_viewers: "No active viewers right now.", legend: "Activity",
        click_hint: "Click a country to see the channels watched from there.",
        channels_watched: "Channels watched from this country (last 7 days)",
        no_channels: "No channel watched from this country recently.",
        realtime_note: "Auto-refreshes every 25s · active viewers over the last 2 minutes.",
      },
      browse: {
        tv: "Televisions", radio: "Radios", all_media: "All channels", count: "{{n}} channel(s) available",
        all: "All", province: "Province", all_provinces: "All provinces", language: "Language", all_languages: "All languages",
        category: "Category", all_categories: "All categories",
        sort_popular: "Popular", sort_live: "Live", sort_recent: "Recent", sort_name: "Name (A-Z)",
        certified_only: "Certified", certified_hint: "Officially certified channels (support available)",
        empty: "No channel matches these filters.",
      },
      detail: {
        listen_live: "Listen live", listening: "Listening", support: "Support", favorites: "Favorites", saved: "Saved",
        copy_link: "Copy link", on_air: "On air", view_grid: "View schedule", hide_grid: "Hide schedule",
        today: "Today", no_program: "No program scheduled today.", ongoing: "ongoing", remind: "Remind me",
        discover_also: "Discover also", comments: "Comments", reply_to: "Reply to", your_reply: "Your reply…",
        add_comment: "Add a comment…", login_to_comment: "Sign in to comment", be_first: "Be the first to comment!",
        reply: "Reply", report_success: "Comment reported to moderation.", favorite_added: "Added to favorites",
        favorite_removed: "Removed from favorites", following: "You now follow this channel", unfollowed: "Unfollowed",
        reminder_on: "Reminder set — you'll be notified before it starts", reminder_off: "Reminder removed",
        link_copied: "Link copied!", edited: "edited", certified: "Certified",
        pinned: "Pinned", official_reply: "Official reply",
      },
      auth: {
        login_title: "Welcome back", login_sub: "Sign in to find your favorite channels",
        register_title: "Create an account", register_sub: "Join the Digital Channels of DRC community",
        email: "Email", password: "Password", first_name: "First name", last_name: "Last name",
        login_btn: "Sign in", register_btn: "Create my account", or: "or", google: "Continue with Google",
        no_account: "No account yet?", have_account: "Already have an account?", signup_link: "Sign up",
        login_link: "Sign in", forgot: "Forgot password?", loading: "Please wait…",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "lang" },
  });

export default i18n;
